import axios from "axios";

// create an axios instance
const service = axios.create({
  baseURL: "https://chkapi.dbshopplus.com",
  // baseURL: "http://192.168.31.185:8083/",
  // baseURL: "http://117.78.17.161:8083/",
  // withCredentials: true, // send cookies when cross-domain requests 跨域问题
  // baseURL: "http://123.57.204.29:8081", // url = base api url + request url
  timeout: 15000, // request timeout
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  },
});

// request拦截器 request interceptor
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code && res.code !== 1) {
      return Promise.reject(res || "error");
    } else {
      return Promise.resolve(res);
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export default service;
